import { APP_PERMISSIONS } from '@exam-management/permissions';
import {
  QConfigGeneratorDetailsHeader,
  QConfigGeneratorDetailsProvider,
} from '@exam-management/qconfig-generator-details';
import { useParams } from '@exam-management/router';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function QConfigGeneratorDetailsLayout() {
  const { qConfigGeneratorId } = useParams(
    '/exam-courses/:courseId/qconfig-generators/:qConfigGeneratorId',
  );
  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.EXAM.QCONFIG.VIEW]}>
      <QConfigGeneratorDetailsProvider qconfigGeneratorId={qConfigGeneratorId}>
        <QConfigGeneratorDetailsHeader />
        <Outlet />
      </QConfigGeneratorDetailsProvider>
    </PermissionGuard>
  );
}
